/**
 * This funciton find access to module
 * @param {Array} permissions 
 * @param {String} name 
 */
const permisionByModule = (permissions = {}, name = '') => permissions[name.toLowerCase()]

/**
 * This funciton find action to access to module
 * @param {Array} permissions 
 * @param {String} name 
 */
const actionsByModule = (permissions = {}, currentModule = '', action = '') => {
  const module = currentModule.toLowerCase()
  
  if (!permissions[module]) {
    return null
  }

  return permissions[module][action.toLowerCase()]
}

export {
  permisionByModule, actionsByModule
}